( function( app ) {
  const COMPONENT = {
    init: function() {
      const mq = window.matchMedia( '(min-width: 768px)' );

      const applyTransform = () => {
        const contents = document.querySelectorAll( '.cta-cards__content' );
        contents.forEach( ( content ) => {
          if ( !$( content ).find( '.cta-cards__description' ).length ) return;

          const offset = $( content ).find( '.cta-cards__description' ).outerHeight();
          $( content ).css( 'transform', mq.matches ? `translateY( ${offset}px )` : '' );
        } );
      };

      applyTransform();
      mq.addEventListener( 'change', applyTransform );
      window.addEventListener( 'resize', applyTransform );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'cta-cards', COMPONENT );
} )( app );
